/* eslint-disable react/prop-types */
import React, { createContext } from 'react';
import proptypes from 'prop-types';
const { node, string } = proptypes;

import { useDenyClearVerification } from '../hooks/useDenyClearVerification'

export const defaultContext = {
  data: {},
  loading: true,
  error: '',
  executeRequest: async () => {},
};

export const DenyClearVerificationApiContext = createContext(defaultContext);

const DenyClearVerificationApiProvider = ({
  state,
  children
}) => {

  return (
    <DenyClearVerificationApiContext.Provider
      value={
        { ...useDenyClearVerification({ state }) }
      }
    >
      {children}
    </DenyClearVerificationApiContext.Provider>
  );
};

DenyClearVerificationApiProvider.propTypes = {
  state: string.isRequired,
  children: node.isRequired
};

export default DenyClearVerificationApiProvider;
